import React from "react"
import clsx from "clsx"
import Switch from "../../Switch/Switch"
import AdditionalCustomerFieldBuilderErrors from "../AdditionalCustomerFieldBuilderErrors"

class AdditionalCustomerFieldBuilderGeneral extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="general">
        {this.renderErrors()} 
        {this.renderGeneralForm()}
      </div>
    )
  }

  renderGeneralForm() {
    return (
      <div>
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('field')}</label>
              <input
                id="field" 
                type="text" 
                name="field" 
                className={this.renderFieldClasses('field') } 
                value={this.props.field} 
                onChange={this.props.onChangeField} 
              />
              { this.renderFieldErrors('field') }
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group" >
              <label>{I18n.t('type')}</label>
              <select className='form-control' defaultValue={this.props.field_type || I18n.t("please_select_one")} onChange={this.props.onChangeType}>
                <option value="please_select_one" disabled>{I18n.t("please_select_one")}</option>
                <option>{I18n.t('date_field')}</option>
                <option>{I18n.t('number_input')}</option>
                <option>{I18n.t('phone_number')}</option>
                <option>{I18n.t('select_box')}</option>
                <option>{I18n.t('text_area')}</option>
                <option>{I18n.t('text_field')}</option>
              </select>
            </div>
          </div>

          {this.props.field_type == 'numbered_scale' 
            ? <div className="col-md-3">
                <div className="form-group">
                  <label>{I18n.t('how_many')} <span className="ss-help help" title={I18n.t('how_many_helper_text')}></span></label>
                  <NumberSpinner />
                </div>
              </div>
            : null}

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('required')} <span className="ss-help help" title={I18n.t('required_helper_text')}></span></label>
              <Switch 
                onText="yes" 
                offText="no" 
                onChange={this.props.onChangeRequired} 
                value={this.props.required} 
                switchId="customer-field-required-switch"
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  /** Error Handling **/

  renderErrors() {
    var errors = AdditionalCustomerFieldBuilderErrors.general(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map( (error) => {
        idx = idx + 1;
        return <li key={idx}><b>&#x2022;</b> {error}</li>;
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldClasses(field) {
    var classname = 'form-control';
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors';
    }
    return classname;
  }

}

export default AdditionalCustomerFieldBuilderGeneral